import React from "react";
import {Alert} from "react-bootstrap";

type InfoBannerProps = {
    children: React.ReactNode;
    variant?: 'info' | 'warning' | 'success';
};
const InfoBanner = ({children,variant='info'}:InfoBannerProps): JSX.Element => {
return(
<Alert variant={variant} className="mb-9">
    {children}
</Alert>
);
};
export default InfoBanner;
